<template>
  <div class="container-fluid">
    <card>
      <template slot="header">
        <h4>آخرین ورود های کاربر</h4>
        <hr />
      </template>
      <template slot="content">
        <bnp-grid :hasRowNum="true" :Sortable="true" :key="keys" :propsColumn="columns" :propsRows="rows" :action="false"></bnp-grid>
      </template>
    </card>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'

export default {
  components: { Card, BnpGrid },
  data() {
    return {
      keys: 0,
      rows: [],
      columns: [
        {
          id: 101796,
          name: 'dateTimeInsert',
          visibility: true,
          width: 0,
          indexCol: 0,
          label: 'تاریخ',
          sort: false,
        },
        {
          id: 101796,
          name: 'message',
          visibility: true,
          width: 0,
          indexCol: 0,
          label: 'وضعیت ورود',
          sort: false,
        },
        {
          id: 101796,
          name: 'ip',
          visibility: true,
          width: 0,
          indexCol: 0,
          label: 'IP',
          sort: false,
        },
      ],
    }
  },
  methods: {
    GetData() {
      this.$PostData({ Action: 'LoginHistory', Method: 'POST', ArryfildValue: { Id: this.$session.get('UserInfo').tblUserId } }).then((result) => {
        this.rows = result
        this.keys++
      })
    },
  },
  created() {
    this.GetData()
  },
}
</script>
